export const track_event = (eventName, params) => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    const url = new URL(window.location.href);
    if (url && url.hostname && !url.hostname.indexOf('localhost') > -1) {
      mixpanel.track(eventName, params);
    }
  }
};
